const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconEstrella(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.03 19.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.14,19.08a.47.47,0,0,1-.3-.1.51.51,0,0,1-.2-.49l1.08-6.28L.15,7.77A.53.53,0,0,1,0,7.25a.51.51,0,0,1,.41-.34L6.74,6,9.57.28A.5.5,0,0,1,10,0h0a.51.51,0,0,1,.45.28L13.29,6l6.32.92a.51.51,0,0,1,.4.34.51.51,0,0,1-.13.52l-4.57,4.44,1.08,6.28a.49.49,0,0,1-.2.49.47.47,0,0,1-.52,0l-5.65-3L4.37,19A.46.46,0,0,1,4.14,19.08ZM1.58,7.76l4,3.92a.48.48,0,0,1,.14.44l-1,5.54,5-2.61a.49.49,0,0,1,.47,0l5,2.61-1-5.54a.49.49,0,0,1,.15-.44l4-3.92L12.89,7a.51.51,0,0,1-.38-.28L10,1.63l-2.49,5A.54.54,0,0,1,7.15,7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstrella);
export default __webpack_public_path__ + "static/media/icon_estrella.da33436baec85e7ee8a5c0372595721c.svg";
export { ForwardRef as ReactComponent };